import Scalar from "src/libs/scalars/scalars/Scalar"
import { ICompositeWidgetProps } from "../LandingCompositeWidget"
import { SCALAR_TYPES, VerticalType } from "src/libs/scalars/interface/IScalarForm"
import { MediaEditableDisabled, MediaNotEditDisabled } from "src/libs/scalars/scalars/Media"
import { MediaChooser } from "src/libs/useful"
import FieldInput from "src/libs/scalars"
import { __ } from "src/libs/utilities"

export interface IMarriageItemScalarProps extends ICompositeWidgetProps {
   
}
const MarriageItemScalar = (props: IMarriageItemScalarProps): JSX.Element => {
    return <>
        <Scalar  
            value={ props.value }
            editable={props.editable }
            subtitle={props.title}
            notClear
            rowClassName="width-auto"
            vertical={ VerticalType.VERTICAL }
            enabledForm={ <MarriageItemScalarEnabled {...props} /> }  
            desabledForm={ <MarriageItemScalarDisable {...props} /> }   
            subMenus={props.subMenus}
            onSubMenu={props.onSubmenu}
        />
    </>
}
export default MarriageItemScalar

const MarriageItemScalarDisable = (props: IMarriageItemScalarProps): JSX.Element => {
    return props.onChange 
          ?
          <MediaEditableDisabled {...props} />
          :
          <MediaNotEditDisabled {...props} />
}

const MarriageItemScalarEnabled = (props: IMarriageItemScalarProps): JSX.Element => {
    const onMediaChange = (fileData: string, file: any ) => { 
        if( props.onChange) {
            const value = {
                ...props.value,
                src: fileData
            }
            // console.log( value, props.dataName, file )
            props.onChange( value, props.dataName, file )
        }
    }
    const onChange = (value: any, field: string, dop: any) => {
        if( props.onChange) {
            const _value = {
                ...props.value,
                [field]: value
            }
            console.log( _value, props.dataName, "" )
            props.onChange( _value, props.dataName, "" )
        }
    }
    return <div className="m-1 p-3 bg-contrast-secondary-opacity w-100">
        <MediaChooser
            prefix={`_${ props.dataName ? props.dataName: "" }`} 
            url={props.value?.src || ""}
            id={ props.dataName ? "" + props.dataName : "" } 
            padding={0}
            height={ 120 }
            //width={ width }
            //tab={ tab }
            //hideLib={ hideLib }
            //accept={ accept }
            //isUploadHide={ false }
            //isURLHide={ false }
            //isFileNameHide={true}
            onChange={ onMediaChange }
            //server_url={ "" }
            //limitSize={ 2000000}
            //style={style} 
            //isHideClearBtn=false} 
        />
        <FieldInput
            subtitle={__("Link")}
            editable
            noDefault
            notClear
            rowClassName="width-auto"
            type={ SCALAR_TYPES.STRING }
            value={props.value?.link_url || ""}
            field="link_url"
            onChange={onChange}
        />
        <FieldInput
            subtitle={__("Link target")}
            editable
            noDefault
            type={ SCALAR_TYPES.TAGS } 
            values={[
                {
                    _id: "_blank",
                    title: "Over window",
                },
                {
                    _id: "_self",
                    title: "This window",
                },
            ]}
            rowClassName="width-auto"
            default="_blank"
            notClear
            value={props.value?.link_target || ""}
        />
        <FieldInput
            subtitle={__("CSS classes")}
            editable
            noDefault
            notClear
            rowClassName="width-auto"
            type={ SCALAR_TYPES.STRING }
            value={ props.value?.className }
        />
        <FieldInput
            title={__("CSS style")}
            editable
            noDefault
            type={ SCALAR_TYPES.CSS_PROPERTIES }
            value={ props.value?.style }
        />
        <FieldInput
            subtitle={__("Border")}
            editable
            noDefault
            notClear
            rowClassName="width-auto"
            type={ SCALAR_TYPES.BORDER }
            value={ props.value?.border }
        />
    </div>
}